import React from "react";
import Header from "../Component/Common/Header/Header";
import MainComp from "../Component/LandingPage/MainComponent";
function HomePage() {
  return (
    <div>
      <Header />
      <MainComp/>
    </div>
  );
}

export default HomePage;
